import React, { Component } from "react";
import { toast } from 'react-toastify'; // FIX 20260729-toastimport
import {
  canUpdateAnimationMarker,
  canEditComment,
  canUseReplyFeature,
  canDeleteCommentUserLogin,
  canDeleteAnimationMarker,
  canDeleteAnimationMarkerPublicUser,
  canUserNotPermission,
  canCreateCommentPublicUser
} from "../authorizations";
import moment from "moment";
import { Button, CardLink } from "reactstrap";
import iconPenEdit from "../ui/icons/iconPenEdit";
import iconBin from "../ui/icons/iconBin.svg";
import iconReply from "../ui/icons/iconReply.png";
import iconPaperclip from "../ui/icons/iconPaperclip";
import TextEditor from "./TextEditor";
import objectToFormdata from "object-to-formdata";
import { renderByFileUrl } from "../util/buildUrl";
import UserToSelect from "./UserToSelect";
import apiClient from "../util/api-client";
import TextEditorWidgetComponent from "./TextEditorWidgetComponent";
import { isValidAttachFiles, isValidBodyLength } from '../util/checkValidate'; // FIX 20260929-bodymax
import iconDeleteFile from "../../../assets/images/icon_x_circle.svg";
import userIcon from '../../../assets/images/user_icon_2.png'
import ModalShowPopupNotifyReplyToNotLogin from './ModalShowPopupNotifyReplyToNotLogin'

export default class CommentDetail extends Component {
  constructor(props) {
    super(props);

    const { selectedMarker } = this.props;

    this.state = {
      body: "",
      replyBody: "",
      isSubmitting: false,
      isReplying: false,
      isOpenModalTo: false,
      disabledButton: true,
      files: [],
      uploadFiles: [],
      editorSetting: {
        borderColor: "#E60C11",
      },
      editor: null,
      isEditing: false,
      status: null,
      selectedMembers: [],
      editor: null,
      editorSetting: {
        borderColor: '#E60C11'
      },
      listFileDelete: [],
      listAllFiles: [],
      isShowModalNotifyOfUserNotLogin: false,
      isShowModalNotLogin: !gon.is_not_show_modal_reply_akaire_to_not_login
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { selectedMarker } = this.props;

    if (prevProps?.selectedMarker?.id !== this.props?.selectedMarker?.id) {
      this.setState({
        body: this.props?.selectedMarker?.body || "",
        isSubmitting: false,
        isReplying: false,
        isOpenModalTo: false,
        disabledButton: true,
        uploadFiles: [],
        listAllFiles: this.fetchListAllFile() || [],
        listFileDelete: [],
        files: this.props?.selectedMarker?.files || [],
        editorSetting: {
          borderColor: "#E60C11",
        },
        editor: null,
        isEditing: false,
        status: this.props?.selectedMarker?.status,
        selectedMembers: this.props.selectedMarker?.usersToInReplyComent,
        editor: null,
        editorSetting: {
          borderColor: '#E60C11'
        },
        isShowModalNotifyOfUserNotLogin: false,
      });
      const m = this.props.selectedMarker;
      if (m && !m.isComment && (!m.files || !m.files.length)) {
        // FIX 20260728-publicattach: 一覧から添付が渡っていれば通信せずそのまま使う
        if (Array.isArray(m.attachment_files)) {
          const files = m.attachment_files;
          this.setState({ files, listAllFiles: files.map((f) => ({ id: f.id, name: decodeURI((f.file_object?.url || '').split('/').pop() || '') })) });
        } else {
          apiClient().get(`/akaire_feature/animation_markers/${m.parent_id}/reply_comments/${m.id}`).then((res) => {
            const files = res.data?.attachment_files || [];
            this.setState({ files, listAllFiles: files.map((f) => ({ id: f.id, name: decodeURI((f.file_object?.url || '').split('/').pop() || '') })) });
          // FIX 20260728-publicattach: 握りつぶさず原因が分かるように記録する（画面のメッセージは変えない）
          }).catch((e) => { console.warn('[reply_comments] 添付の取得に失敗しました', { parentId: m.parent_id, id: m.id, status: e?.response?.status, error: e }); });
        }
      }
    }

    if (!selectedMarker) this.removeClassHighLightComment()
  }

  fetchListAllFile() {
    const { isReplying } = this.state
    if(isReplying) return []
    const listFile = []
    if (this.props?.selectedMarker?.files) {
      $.each(this.props?.selectedMarker?.files, function(k, file) {
        listFile.push({id: file.id, name: decodeURI(file.file_object.url.split('/').slice(-1)[0]) })
      });
    }
    return listFile;
  }

  fetchListAllFileForEdit() {
    const selectedMarker = this.props.selectedMarker;
    if (!selectedMarker?.files) return [];
    const listFile = [];
    $.each(selectedMarker.files, function(k, file) {
      if (file?.file_object?.url) {
        listFile.push({ id: file.id, name: decodeURI(file.file_object.url.split('/').slice(-1)[0]) });
      }
    });
    return listFile;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  toggleModalReply = () => {
    this.setState({isShowModalNotifyOfUserNotLogin: !this.state.isShowModalNotifyOfUserNotLogin})
  }

  handleClickOutside(event) {
    // FIX 20260730-outsidecancel: 「入力中のコメントがあります」確認モーダルの表示中は閉じない。
    // 外側クリックで確認モーダルが出た同じ mousedown でこの処理も走り、キャンセルを押す前に
    // selectedMarker=null となって編集/返信モードが解除されていた。モーダル非表示時は従来どおり。
    const __tmCfm = document.getElementById("tm-detail-confirm-backdrop");
    if (__tmCfm && __tmCfm.style.display !== "none") return;
    if ($(event.target).hasClass('modal-style modal-not-reply-to-not-login') ||
        $('.modal-not-reply-to-not-login').length > 0 && $('.modal-not-reply-to-not-login')[0].contains(event.target) ||
        $('.swal2-container').find('.popup-confirm-no-to').length > 0) {
      return
    }
    // ★FIX(20260405): marker/card/dot要素クリック時はselectedMarkerをnullにしない
    // mousedown→click の間にselectedMarker=nullになると、±1秒フィルターが誤動作し
    // 旧位置の範囲指定markerが一瞬表示されるため。clickイベントで正しいmarkerが再セットされる。
    if (event.target.closest &&
        (event.target.closest('.comment-marker-point') ||
         event.target.closest('.animation-marker') ||
         event.target.closest('.tm-pen-toolbar-root') ||
         event.target.closest('.tm-badge-wrapper') ||
         event.target.closest('.tm-view-mode-badge-jsx') ||
         event.target.closest('.tm-card'))) {
      return;
    }
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.updateSelectedMarker(null);
    }
  }

  onChangeBody = (value) => {
    if(this.state.isReplying) {
      this.setState({ replyBody: value });
    } else if(this.state.isEditing) {
      this.setState({ body: value });
    }
    this.setState({ disabledButton: !value });
  };
  onAddFiles = (files) => {
    // FIX 20260730-attachmax: 編集時は今回追加した分(uploadFiles)だけを数えていたため、
    // 既に付いている添付との合計が10個を超えられた(新規は10個止まりなのに編集で追加でき本番に13個の例あり)。
    // 画面に表示中の添付すべて(既存＋追加、削除した分は除かれる)である listAllFiles を数える。
    // 判定関数(checkValidate.js)と新規側(AnimationMarkerForm.jsx)は変更しない。
    if (!isValidAttachFiles(this.state.listAllFiles || [], files)) return;
    this.setState({ uploadFiles: [...this.state.uploadFiles, ...files] });
  };
  onFileChange = (event, files) => {
    const listFileName = []
    const { listAllFiles } = this.state;
    $.each(listAllFiles, function(k, file) {
      listFileName.push(file)
    });
    if (event) {
      const { files } = event.target;

      // FIX 20260730-attachmax: 上と同じ理由。画面に表示中の添付すべてを数える。
      if (!isValidAttachFiles(this.state.listAllFiles || [], files)) {
        event.target.value = null;
        return;
      }
      $.each(files, function(k, file) {
        const id = new Date().getTime() + k
        file.id_temp = id
        listFileName.push({ id: id, name: file.name})
      })
      this.setState({ uploadFiles: [...this.state.uploadFiles, ...files] });
      this.setState({ disabledButton: false, listAllFiles: listFileName })
      event.target.value = null;
    } else {
      if (files) {
        $.each(files, function(k, file) {
          const id = new Date().getTime() + k
          listFileName.push({ id: id, name: file.name})
        })
        this.setState({ uploadFiles: [...this.state.uploadFiles, ...files] });
        this.setState({ disabledButton: false, listAllFiles: listFileName })
      }
    }
  };

  deleteUploadFile = (fileId) => {
    const newUploadFiles = [];
    const newListAllFiles = [];
    const newListDeleteFiles = [];
    const { uploadFiles, listAllFiles, listFileDelete } = this.state;
    $.each(listFileDelete, function(k, id) {
      newListDeleteFiles.push(id)
    })
    $.each(uploadFiles, function(k, file) {
      if (file.id_temp !== fileId) {
        newUploadFiles.push(file)
      }
    })
    $.each(listAllFiles, function(k, file) {
      if (file.id !== fileId) {
        newListAllFiles.push(file)
      } else {
        newListDeleteFiles.push(file.id)
      }
    })
    this.setState(
      { uploadFiles: newUploadFiles, listAllFiles: newListAllFiles,
        listFileDelete: newListDeleteFiles, disabledButton: false }
    );
  }

  /**
   * Check show delete button
   */
  showDeleteMarker(user, marker) {
    const selectedMarker = marker || this.props.selectedMarker;
    const { currentUserId, role, owner, is_project_owner_member } = this.props;
    // currrent user is project owner member and user is null, show delete button
    if (is_project_owner_member && currentUserId && !user) {
      return true;
    }
    if (!user) {
      if (currentUserId) return false;
      const emailTemp = localStorage.getItem('email_temp_of_not_login');
      return !!(emailTemp && selectedMarker.email_temp && selectedMarker.email_temp === emailTemp);
    }
    if (currentUserId != user.id) return false;
    if (currentUserId && user && currentUserId == user.id) return true;
    // current user have role owner, reader, view, edit
    if (currentUserId && canDeleteCommentUserLogin(role)) {
      return canDeleteAnimationMarker(user && user.id, currentUserId, role);
    }
    // current user have role public_user
    if (
      (currentUserId && canUserNotPermission(role) && !!owner) ||
      (!currentUserId && canUserNotPermission(role) && !!owner)
    ) {
      return false;
    }
    // public user
    return canDeleteAnimationMarkerPublicUser(user && user.id, currentUserId);
  }

  updateIsEditing(boolean) {
    this.setState({ isEditing: boolean });
    this.setState({
      isReplying: false,
      files: [],
      listAllFiles: boolean ? (this.fetchListAllFileForEdit() || []) : []
    });
  }

  changeIsShowModalNotLogin = (bolean) => {
    this.setState({ isShowModalNotLogin: bolean });
  }

  updateIsReplying(boolean) {
    const { selectedMarker } = this.props;
    const isShowModal = false
    const defaultSelectedMembers = boolean && selectedMarker?.receivers ? selectedMarker.receivers : [];
    // 非ログイン かつ 返信モードON かつ 未登録（localStorage空）の場合は登録modal表示
    if (boolean && !gon.is_login) {
      const emailTemp = localStorage.getItem('email_temp_of_not_login');
      const userTemp  = localStorage.getItem('user_temp_of_not_login');
      if (!emailTemp || !userTemp) {
        document.dispatchEvent(new KeyboardEvent('keydown', {key: 'Escape', bubbles: true}));
        setTimeout(() => {
          if (typeof window._tmOpenNotLoginModal === 'function') {
            window._tmOpenNotLoginModal();
          }
        }, 150);
        return; // 返信モードへの遷移をブロック
      }
    }

    this.setState({
      isReplying: boolean,
      isEditing: false,
      files: [],
      listAllFiles: [],
      isShowModalNotifyOfUserNotLogin: isShowModal,
      selectedMembers: defaultSelectedMembers
    });
  }

  updateIsOpenModalTo = (boolean) => {
    this.setState({ isOpenModalTo: boolean });
  };

  updateSelectedMember = (selectedMembers) => {
    this.setState({ selectedMembers: selectedMembers });
    this.updateIsOpenModalTo(false);
  };

  removeMemberFromSelected = (memberToRemove) => {
    const { selectedMembers } = this.state;
    const updatedMembers = selectedMembers.filter(member => member.value !== memberToRemove.value);
    this.setState({ selectedMembers: updatedMembers });
  };

  setEditor = (value) => {
    this.setState({ editor: value });
  }

  /**
   * Action update comment status
   */
  onClickUpdate = (values, targetId) => {
    const { onMarkerUpdationCalled } = this.props;

    onMarkerUpdationCalled(values, targetId);
    this.setState({ status: values.status });

    let scrollTopPosition = this.fetchPositionComment(targetId);
    if ($('.marker-' + targetId).length > 0) {
      $('.wrap-animation-preview').animate({
        scrollTop: $('.marker-' + targetId).position().top - 200
      }, 'slow');
    }
    this.keepPositionComment(targetId, scrollTopPosition)
  };

  onSubmitReply = () => {
    const { replyBody, selectedMembers, uploadFiles } = this.state;
    const { currentUserId, reloadMarkers, selectedMarker } =
      this.props;
    const { id, parent_id, isComment } = selectedMarker;

    this.setState({ isSubmitting: true });
    const emailTemp = localStorage.getItem('email_temp_of_not_login');
    const userTemp = localStorage.getItem('user_temp_of_not_login');
    const data = objectToFormdata({
      reply_comment: {
        body: replyBody,
        reply_to: selectedMembers ? selectedMembers.map((option) => option.value) : [],
        user_id: currentUserId,
        ...(emailTemp && userTemp ? { email_temp: emailTemp, user_name_temp: userTemp } : {}),
        attachment_files_attributes: uploadFiles.map((file) => {
          return {
            file_object: file,
          };
        }),
      },
    });
    return apiClient()
      .post(
        `/akaire_feature/animation_markers/${isComment ? id : parent_id}/reply_comments`,
        data
      )
      .then(({ data: { id } }) => {
        reloadMarkers().then((_) => {
          // scrollToReply(id);
        });
      })
      .catch((e) => {
        toast.error("失敗しました。");
        reloadMarkers();
      })
      .finally((_) => this.onSubmitSuccess("reply"));
  };

  onSubmitUpdateMarker = () => {
    const { apiClient, reloadMarkers } = this.props;
    const { body, uploadFiles, listFileDelete } = this.state;

    const data = objectToFormdata({
      animation_marker: {
        body: body,
        animation_marker_files_attributes: uploadFiles.map((file) => {
          return {
            file_object: file,
          };
        }),
      },
      list_delete_files: listFileDelete
    });

    this.setState({ isSubmitting: true, isEditing: false });

    return apiClient
      .patch(
        `animations/${this.props.selectedMarker.animation_id}/animation_markers/${this.props.selectedMarker.id}`,
        data
      )
      .then((_) => {
        this.setState({ isSubmitting: false });
        reloadMarkers();
      })
      .catch((_) => {
        this.setState({ isSubmitting: false });
        toast.error("コメントの投稿に失敗しました。");
      })
      .finally((_) => this.onSubmitSuccess("edit"));
  };

  onSubmitUpdateReply = () => {
    const { reloadMarkers, selectedMarker } = this.props;
    const { id, parent_id } = selectedMarker;
    const { replyBody, body, uploadFiles, listFileDelete } = this.state;
    const data = objectToFormdata({
      reply_comment: {
        body: body,
        attachment_files_attributes: uploadFiles.map((file) => {
          return {
            file_object: file,
          };
        })
      },
      list_delete_files: listFileDelete
    });
    // keepPositionComment(parentReplyId, position)
    return apiClient()
      .patch(
        `/akaire_feature/animation_markers/${parent_id}/reply_comments/${id}`,
        data
      )
      .then((_) => {
        reloadMarkers();
        setTimeout(function () {
          // if (position > 0) {
          //   keepPositionComment(parentReplyId, position)
          // }
        }, 300);
      })
      .catch((e) => console.error(e.message))
      .finally((_) => this.onSubmitSuccess("edit"));
  };

  onClickDelete(targetId) {
    const { selectedMarker, reloadMarkers } = this.props
    const { animationSelectCurrent, currentAnimationId, updateSelectedMarker, deleteReplyMarker } =
      this.props;
    if (animationSelectCurrent !== currentAnimationId) return;

    return (event) => {
      event.stopPropagation();
      event.preventDefault();
      Popup.confirm(
        'このコメントを削除します。<br>よろしいですか？',
        {
          confirmText: 'OK',
          success: () => {
            if(selectedMarker.isComment) {
              const { onMarkerDeletionCalled } = this.props;
              onMarkerDeletionCalled(targetId);
            } else {
              deleteReplyMarker(targetId, selectedMarker.parent_id)
              setTimeout(() => {reloadMarkers();}, 200)
            }
            updateSelectedMarker(null);
            this.onSubmitSuccess("delete");
            Popup.alert('コメントを削除しました。')
          }
        }
      )
    };
  }

  onSubmitSuccess = (type) => {
    this.setState({ isSubmitting: false });
    switch (type) {
      case "reply":
        Popup.alert('', '', 'コメントに返信しました。', {kind: 'akaire'});
        if (this.props.updateSelectedMarker) {
          this.props.updateSelectedMarker(null);
        }
        break;
      case "edit":
        Popup.alert('', '', 'コメントを更新しました。', {kind: 'akaire'});
        break;
      case "delete":
        Popup.alert('', '', 'コメントを削除しました。', {kind: 'akaire'});
        break;
    }
  };

  // Setting BUA
  handleSetEditorSetting = (settingData) => {
    this.setState({
      editorSetting: settingData
    })
  };

  onClickAttachmentFile = () => {
    this.refs.fileInput.click();
  }

  fetchPositionComment = (id) => {
    let scrollTopPosition = 0;
    if ($(`.animation-marker-${id}`).length > 0) {
      const divScroll = $(`.animation-marker-${id}`).parents('.items')[0];
      scrollTopPosition = divScroll.scrollTop;
    }
    return scrollTopPosition
  }

  keepPositionComment = (id, scrollTopPosition) => {
    if (scrollTopPosition !== 0) {
      $(`.animation-marker-${id}`).parents('.items').animate({
        scrollTop: scrollTopPosition
      }, 'slow');
    }
  }

  handleSubmitComment = (isReplying) => {
    const { selectedMarker } = this.props
    // FIX 20260929-bodymax 3,000文字を超えたら保存しない（入力・BOXはそのまま）。返信は replyBody、編集は body
    if (!isValidBodyLength(isReplying ? this.state.replyBody : this.state.body)) return;

    if (isReplying) {
      this.handleSubmitReply();
    } else if (selectedMarker.isComment) {
      this.onSubmitUpdateMarker();
    } else {
      this.onSubmitUpdateReply();
    }
  }

  handleSubmitReply = () => {
    var __hasBody = this.state.replyBody && String(this.state.replyBody).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim().length > 0;
    var __hasFile = (this.state.uploadFiles && this.state.uploadFiles.length > 0) || (this.state.listAllFiles && this.state.listAllFiles.length > 0);
    if (!__hasBody && !__hasFile) { toast.error("コメントまたは添付ファイルを入力してください。"); return; }
    this.onSubmitReply();
  }

  sanitizeCol12Spans = (html = '') => {
    return html.replace(/<span\b([^>]*)>/gi, (match, attrs) => {
      const classAttrMatch = attrs.match(/class\s*=\s*(['"])(.*?)\1/i);
      if (!classAttrMatch) return `<span${attrs}>`;

      const originalClass = classAttrMatch[2];
      const filteredClass = originalClass
        .split(/\s+/)
        .filter((cls) => cls && cls !== 'col-12')
        .join(' ');

      const newClassAttr = filteredClass ? `class="${filteredClass}"` : '';
      let updatedAttrs = attrs.replace(classAttrMatch[0], newClassAttr);
      updatedAttrs = updatedAttrs.replace(/\s+/g, ' ').trim();

      return updatedAttrs ? `<span ${updatedAttrs}>` : '<span>';
    });
  };

  renderCommentBody = (body, files) => {
    const sanitizedBody = this.sanitizeCol12Spans(body);
    return (
      <div className="comment-detail-info-body">
        <div className="safe-html-akaire" dangerouslySetInnerHTML={{ __html: sanitizedBody }} />
        <div className="attached-files">
          {files.map((file, i) => {
            return (
              <div className="attached-file my-2" key={i}>
                <a
                  href={file.file_object.url}
                  target="_blank"
                  className="cursor-pointer"
                >
                  {renderByFileUrl(file.file_object.url)}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    )
  }

  renderCommentChildren = (body, files) => {
    const sanitizedBody = this.sanitizeCol12Spans(body);
    return (
      <div className="comment-detail-info-body comment-children">
        <div dangerouslySetInnerHTML={{ __html: sanitizedBody }}></div>
        <div className="attached-files">
          {files.map((file, i) => {
            return (
              <div className="attached-file my-2" key={i}>
                <a
                  href={file.file_object.url}
                  target="_blank"
                  className="cursor-pointer"
                >
                  {renderByFileUrl(file.file_object.url)}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    )
  }

  renderComentDetail(selectedMarker, shouldShowForm) {
    const { currentUserId, role, mobile: isMobile, avatarUrl } = this.props;
    const {
      status,
      body,
      replyBody,
      isSubmitting,
      files,
      isEditing,
      isReplying,
      isOpenModalTo,
      selectedMembers,
      editor,
      uploadFiles,
      disabledButton,
      listAllFiles,
      isShowModalNotifyOfUserNotLogin
    } = this.state;
    const showAvatarUrl = selectedMarker.user?.chat_avatar_url;

    if (shouldShowForm) return (<></>)

    return (
      <div className="comment-detail-group">
        {isOpenModalTo && (
          <UserToSelect
            isOpenModalTo={isOpenModalTo}
            receivers={selectedMarker.receivers}
            initialSelectedMembers={selectedMembers}
            updateSelectedMember={this.updateSelectedMember}
            onClose={this.updateIsOpenModalTo}
          ></UserToSelect>
        )}

        <div className={`comment-detail-info d-flex justify-content-between${(isEditing || isReplying) ? ' is-editing' : ''}`}>
          <div className="comment-detail-user-info d-flex">
            {showAvatarUrl ? (
              <img className="comment-detail-info-avatar" src={showAvatarUrl}></img>
            ) : (
              selectedMarker.user?.name[0] ? (
                <span className="comment-detail-info-avatar">
                {selectedMarker.user?.name[0]}
              </span>
              ) : (<img className="comment-detail-info-avatar for-not-login" style={{backgroundColor: 'none'}} src={userIcon}></img>)
            )}

            {isEditing || isReplying ? (
              <div className="w-100 position-relative">
                {
                  isReplying && (
                    <div className="show-reply-source-text-wrapper">
                      <div>返信元の文章を表示</div>
                      <div className="show-reply-source-text-tooltip p-2 mt-1">
                        <div className="comment-detail-info d-flex justify-content-between">
                          <div className="comment-detail-user-info d-flex">
                            {1 === 2 ? (
                              <img className="comment-detail-info-avatar" src={ showAvatarUrl ? showAvatarUrl : '' }></img>
                            ) : (
                              <span className="comment-detail-info-avatar">
                                {selectedMarker.user?.name[0]}
                              </span>
                            )}
                            { this.renderCommentBody(body, files) }
                          </div>
                        </div>

                        <div className="comment-detail-action">
                          <div className="comment-detail-action-info d-flex">
                            <div className="comment-detail-user-name text-ellipsis max-width-195px">
                              {selectedMarker.user?.name || selectedMarker.user_name_temp || ''}
                            </div>
                            <div className="comment-detail-created-at">
                              {moment(selectedMarker.created_at).format(
                                "YYYY/MM/DD HH:mm:ss",
                                "Asia/Tokyo"
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
                {selectedMembers && !isEditing && (
                  <div className="comment-detail-to-list-reply d-flex position-absolute">
                    <div className="icon-to cursor-pointer" onClick={() => { this.updateIsOpenModalTo(true); }}>TO</div>
                    <div className="list-user tm-list-user-single-line" data-all-members={JSON.stringify(((selectedMarker && selectedMarker.receivers) || []).map(m => ({value: m.value, label: m.label})))} data-selected-members={JSON.stringify(selectedMembers.map(m => ({value: m.value, label: m.label})))}>
                      <span className="tm-to-members-text">
                        {selectedMembers.map((m, i) => (
                          <span
                            key={i}
                            className="cursor-pointer tm-to-member-chip"
                            onClick={() => this.removeMemberFromSelected(m)}
                            title="クリックで除外"
                          >{m.label}{i < selectedMembers.length - 1 ? ', ' : ''}</span>
                        ))}
                      </span>
                      {(() => {
                        const allCount = ((selectedMarker && selectedMarker.receivers) || []).length;
                        const excludedCount = allCount - selectedMembers.length;
                        const isAllSelected = excludedCount === 0;
                        return (
                          <React.Fragment>
                            <span className="tm-to-overflow-count tm-to-overflow-clickable">(除外:{excludedCount})</span>
                            <label className="tm-to-clear" style={{display:'inline-flex',alignItems:'center',gap:'5px',cursor:'pointer',userSelect:'none',marginLeft:'8px',border:'1px solid #aaa',borderRadius:'3px',background:'transparent',padding:'2px 6px',marginTop:'2px'}}>
                              <input
                                type="checkbox"
                                checked={isAllSelected}
                                style={{width:'13px',height:'13px',cursor:'pointer',accentColor:'#555',flexShrink:0,margin:0}}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  if (e.target.checked) {
                                    this.updateSelectedMember(((selectedMarker && selectedMarker.receivers) || []));
                                  } else {
                                    this.updateSelectedMember([]);
                                  }
                                }}
                              />
                              <span style={{fontSize:'11px',color:'#333',fontWeight:'700',whiteSpace:'nowrap',marginTop:'1px'}}>全員</span>
                            </label>
                          </React.Fragment>
                        );
                      })()}
                    </div>
                  </div>
                )}
                <TextEditor
                  key={`text-editor-${isReplying ? 'reply' : 'edit'}-${selectedMarker?.id}`}
                  files={files}
                  onChangeBody={this.onChangeBody}
                  onAddFiles={this.onAddFiles}
                  disabled={isSubmitting}
                  setEditor={this.setEditor}
                  rows={4}
                  placeholder={"ここにコメントを入力"}
                  initialValue={isReplying ? "" : this.props.selectedMarker.body}
                  inputId="animation-marker-body-comment"
                  is_comment={true}
                  isReplying={isReplying}
                />
              </div>
            ) : null}
            {!isEditing && !isReplying && !selectedMarker.isComment && (
              <div className="show-reply-source-text-wrapper">
                <div>返信元の文章を表示</div>
                <div className="show-reply-source-text-tooltip p-2 mt-1">
                  <div className="comment-detail-info d-flex justify-content-between">
                    <div className="comment-detail-user-info d-flex">
                      <span className="comment-detail-info-avatar">
                        {selectedMarker.parentUser?.name?.[0]}
                      </span>
                      { this.renderCommentBody(selectedMarker.parentsComment, []) }
                    </div>
                  </div>
                  <div className="comment-detail-action">
                    <div className="comment-detail-action-info d-flex">
                      <div className="comment-detail-user-name text-ellipsis max-width-195px">{selectedMarker.parentUser?.name || selectedMarker.parentUserNameTemp || ''}</div>
                      <div className="comment-detail-created-at">{moment(selectedMarker.parentCreatedAt).format("YYYY/MM/DD HH:mm:ss", "Asia/Tokyo")}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {!isEditing && !isReplying && selectedMarker.isComment && (
            this.renderCommentBody(body, files)
          )}
          {selectedMarker.isComment ? (
            <div className="comment-detail-record-info d-flex">
              {
                (isEditing || isReplying) && <TextEditorWidgetComponent
                  mobile={isMobile}
                  settingEditor={this.handleSetEditorSetting}
                  closeEditor={() => {}}
                  fileUpload={()=>{}}
                  editor={editor}
                  onlyBUA={true}
                />
              }
              {selectedMarker.time != null && selectedMarker.isVideo && (
                selectedMarker.periodEnd ? (
                  <div className="comment-detail-time" style={{position:'relative'}}>
                    <span style={{position:'relative',display:'inline-block',verticalAlign:'middle',marginRight:'8px',cursor:'pointer'}}
                      ref={(el) => { if (!el || el._tmBound) return; el._tmBound = true; function getTip() { let tip = document.getElementById('tm-seek-tip-global'); if (!tip) { tip = document.createElement('div'); tip.id = 'tm-seek-tip-global'; tip.textContent = '始点・終点をクリックすると、その地点に移動します'; Object.assign(tip.style, {display:'none',position:'fixed',background:'#1e1e2e',color:'#e0e0e0',padding:'6px 10px',borderRadius:'6px',border:'1px solid #3a3a55',boxShadow:'0 4px 16px rgba(0,0,0,.5)',fontSize:'11px',whiteSpace:'nowrap',zIndex:'2147483647',pointerEvents:'none'}); document.body.appendChild(tip); } return tip; } function showTip() { const tip = getTip(); const box = document.querySelector('.comment-detail-container.tm-detail-active'); if (box) { const r = box.getBoundingClientRect(); tip.style.left = (r.left + r.width / 2) + 'px'; tip.style.top = (r.top + r.height / 2) + 'px'; tip.style.transform = 'translate(-50%, -50%)'; } tip.style.display = 'block'; } el.addEventListener('mouseenter', showTip); el.addEventListener('mouseleave', function() { const tip = document.getElementById('tm-seek-tip-global'); if (tip) tip.style.display = 'none'; }); el.addEventListener('click', function(e) { e.stopPropagation(); const tip = getTip(); if (tip.style.display === 'block') { tip.style.display = 'none'; } else { showTip(); } }); }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 12 16" style={{display:'block',color:'rgb(0,102,255)',filter:'drop-shadow(0 1px 3px rgba(0,102,255,0.6))'}}><path d="M6 0 C3 0 0 2.7 0 6 C0 10.5 6 16 6 16 C6 16 12 10.5 12 6 C12 2.7 9 0 6 0 Z" fill="currentColor"/><circle cx="6" cy="5.5" r="2" fill="white"/></svg>
                    </span>
                    <span style={{textDecoration:'underline',cursor:'pointer'}} onClick={(e) => { e.stopPropagation(); const _pane = e.target.closest('.comment-detail-container')?._tmDetailPane; const v = (_pane || document).querySelector('.video-react-video, video'); if (v) { v.pause(); v.currentTime = selectedMarker.time; return; } const c = _pane ? _pane.querySelector('#animation-player') || document.getElementById('animation-player') : document.getElementById('animation-player'); if (!c) return; const fk = Object.keys(c).find(k => k.startsWith('__reactFiber') || k.startsWith('__reactInternalInstance')); if (!fk || fk.startsWith('__reactProps')) return; let n = c[fk]; for (let i = 0; i < 20 && n; i++) { const p = n.memoizedProps; if (p && p.player && typeof p.player.getCurrentTime === 'function') { p.player.pauseVideo(); p.player.seekTo(selectedMarker.time, true); return; } const s = n.memoizedState; if (s) { let st = s; for (let j = 0; j < 10 && st; j++) { const mv = st.memoizedState || st; if (mv && mv.player && typeof mv.player.getCurrentTime === 'function') { mv.player.pauseVideo(); mv.player.seekTo(selectedMarker.time, true); return; } st = st.next; } } n = n.return; } }}>{moment.utc(selectedMarker.time * 1000).format("HH:mm:ss.S")}</span>
                    {' ~ '}
                    <span style={{textDecoration:'underline',cursor:'pointer'}} onClick={(e) => { e.stopPropagation(); const _pane = e.target.closest('.comment-detail-container')?._tmDetailPane; const v = (_pane || document).querySelector('.video-react-video, video'); if (v) { v.pause(); v.currentTime = selectedMarker.periodEnd; return; } const c = _pane ? _pane.querySelector('#animation-player') || document.getElementById('animation-player') : document.getElementById('animation-player'); if (!c) return; const fk = Object.keys(c).find(k => k.startsWith('__reactFiber') || k.startsWith('__reactInternalInstance')); if (!fk || fk.startsWith('__reactProps')) return; let n = c[fk]; for (let i = 0; i < 20 && n; i++) { const p = n.memoizedProps; if (p && p.player && typeof p.player.getCurrentTime === 'function') { p.player.pauseVideo(); p.player.seekTo(selectedMarker.periodEnd, true); return; } const s = n.memoizedState; if (s) { let st = s; for (let j = 0; j < 10 && st; j++) { const mv = st.memoizedState || st; if (mv && mv.player && typeof mv.player.getCurrentTime === 'function') { mv.player.pauseVideo(); mv.player.seekTo(selectedMarker.periodEnd, true); return; } st = st.next; } } n = n.return; } }}>{moment.utc(selectedMarker.periodEnd * 1000).format("HH:mm:ss.S")}</span>
                  </div>
                ) : (
                  <div className="comment-detail-time">
                    {moment.utc(selectedMarker.time * 1000).format("HH:mm:ss.S")}
                  </div>
                )
              )}
              <div className="comment-detail-record-circle d-flex align-items-center">
                <div className={`status-field ${!canCreateCommentPublicUser(role) && ('disabled') }`}>
                  {canUpdateAnimationMarker(role) &&
                    (status === "initial" ? (
                      <div data-tip data-for="marker-tooltip">
                        <CardLink
                          onClick={() => {
                            this.onClickUpdate(
                              { status: "completed" },
                              selectedMarker.id
                            );
                          }}
                          href="#"
                        >
                          <span className="far fa-circle status-circle"></span>
                        </CardLink>
                      </div>
                    ) : (
                      <div data-tip data-for="marker-tooltip">
                        <CardLink
                          onClick={() => {
                            this.onClickUpdate(
                              { status: "initial" },
                              selectedMarker.id
                            );
                          }}
                          href="#"
                        >
                          <span className="far fa-check-circle status-circle status--completed"></span>
                        </CardLink>
                      </div>
                    ))}
                </div>
                <div
                  className="border-none numerical-order-container d-flex justify-content-center align-items-center"
                  style={{ backgroundColor: selectedMarker.border_color }}
                >
                  <div className="comment-no">{selectedMarker.index != null ? selectedMarker.index : selectedMarker.number_comment}</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="comment-detail-record-info d-flex">
              {
                (isEditing || isReplying) && <TextEditorWidgetComponent
                  mobile={isMobile}
                  settingEditor={this.handleSetEditorSetting}
                  closeEditor={() => {}}
                  fileUpload={()=>{}}
                  editor={editor}
                  onlyBUA={true}
                />
              }
            </div>
          )}
        </div>

        {selectedMembers && !isEditing && !isReplying && (
          <div>
            <div className="comment-detail-to-list d-flex">
              <div className="icon-to">TO</div>
              <div className="list-user tm-list-user-single-line" data-all-members={JSON.stringify(((selectedMarker && selectedMarker.receivers) || []).map(m => ({value: m.value, label: m.label})))} data-selected-members={JSON.stringify(selectedMembers.map(m => ({value: m.value, label: m.label})))}>
                <span className="tm-to-members-text">
                  {selectedMembers.map((m, i) => m.label + (i < selectedMembers.length - 1 ? ', ' : '')).join('')}
                </span>
                {selectedMembers.length > 0 && (
                  <span className="tm-to-overflow-count tm-to-overflow-clickable">(除外:{((selectedMarker && selectedMarker.receivers) || []).length - selectedMembers.length})</span>
                )}
              </div>
            </div>
            { this.renderCommentChildren(body, files) }
          </div>
        )}

        <div className="comment-detail-action d-flex">
          <div className="d-flex comment-action">
            {
              (canEditComment(
                currentUserId,
                selectedMarker.user && selectedMarker.user.id
              ) || (
                !currentUserId &&
                !selectedMarker.user &&
                selectedMarker.email_temp &&
                selectedMarker.email_temp === localStorage.getItem('email_temp_of_not_login')
              )) && (
                <CardLink
                  onClick={() => this.updateIsEditing(true)}
                  href="javascript:void(0)"
                >
                  <div className="circle circle-edit-icon">
                    <img className="edit-icon" src={iconPenEdit} />
                  </div>
                  編集
                </CardLink>
              )
            }

            { (canCreateCommentPublicUser(role) || role === 'public_visitor' || role === 'reader') && (
              (!isReplying && canUseReplyFeature(role)) && (
                <CardLink
                  onClick={() => {
                    this.updateIsReplying(true);
                  }}
                  href="javascript:void(0)"
                >
                  <img className="circle" src={iconReply}/>
                  返信
                </CardLink>
              ))
            }
            {this.showDeleteMarker(selectedMarker.user) && (
              <CardLink
                onClick={this.onClickDelete(selectedMarker.id)}
                href="javascript:void(0)"
              >
                <div className="circle circle-bin-icon">
                  <img className="bin-icon" src={iconBin} />
                </div>
                削除
              </CardLink>
            )}
          </div>

          <div className="comment-detail-action-info d-flex">
            {(() => {
              const myEmail = localStorage.getItem('email_temp_of_not_login');
              const isMyNotLoginComment = !selectedMarker.user &&
                selectedMarker.email_temp && myEmail &&
                selectedMarker.email_temp === myEmail &&
                !isEditing && !isReplying;
              return (
                <>
                  <div
                    className="comment-detail-user-name text-ellipsis max-width-195px"
                    style={isMyNotLoginComment ? {cursor:'pointer', textDecoration:'underline'} : {}}
                    onClick={() => { if (isMyNotLoginComment && window._tmOpenEditNameModal) window._tmOpenEditNameModal(selectedMarker.user_name_temp); }}
                  >
                    {selectedMarker.user?.name || selectedMarker.user_name_temp || ''}
                  </div>
                  {!selectedMarker.user && selectedMarker.email_temp && (
                    <div
                      className="tm-not-login-email"
                      style={{fontSize:'11px', color:'#aaa', marginLeft:'4px', ...(isMyNotLoginComment ? {cursor:'pointer', textDecoration:'underline'} : {})}}
                      onClick={() => { if (isMyNotLoginComment && window._tmOpenEditNameModal) window._tmOpenEditNameModal(selectedMarker.user_name_temp); }}
                    >
                      <span style={isMyNotLoginComment ? {} : {pointerEvents:'none'}}>{selectedMarker.email_temp}</span>
                    </div>
                  )}
                </>
              );
            })()}
            <div className="comment-detail-created-at">
              {moment(selectedMarker.created_at).format(
                "YYYY/MM/DD HH:mm:ss",
                "Asia/Tokyo"
              )}
            </div>
            <Button
              className="button-send"
              disabled={isSubmitting || (!isEditing && !isReplying) || disabledButton}
              onClick={() => {
                {
                  this.handleSubmitComment(isReplying, selectedMarker)
                }
              }}
            >
              更新
            </Button>
          </div>
        </div>

        {
          (isReplying || isEditing) && (
            <div className="hr"></div>
          )
        }

        {
          (isReplying || isEditing) && (
            <div className="show-detail-upload-file-akaire-page">
              <div className="comment-detail-upload-file d-flex align-items-center">
                <div className="paperclip-box circle" onClick={this.onClickAttachmentFile}>
                  <img src={iconPaperclip} alt="アップロード" />
                </div>
                <input
                  type="file"
                  hidden
                  onChange={this.onFileChange.bind(this)}
                  ref="fileInput"
                  multiple="multiple"
                  accept="image/*, .wav"
                />
              </div>
              {
                listAllFiles.map((file, i) => {
                  return (
                    <div className="d-flex list-file-name justify-content-between align-center">
                      <span key={i} className="text-ellipsis max-width-80percent h-100">{file.name}</span>
                      <span className="attatchment-file-coment-akaire cursor-pointer" onClick={() => this.deleteUploadFile(file.id)}>
                        <img src={iconDeleteFile} alt="アップロード" />
                      </span>
                    </div>
                  )
                })
              }
            </div>
          )
        }
        <ModalShowPopupNotifyReplyToNotLogin isOpen={isShowModalNotifyOfUserNotLogin} togglePopup={this.toggleModalReply}
        changeIsShowModalNotLogin={this.changeIsShowModalNotLogin}/>
      </div>
    );
  }

  removeClassHighLightComment() {
    if ($('#show-period').val() == 'true') return

    $('.reply-comment-item').removeClass('highlight');
    $('.animation-marker').css('background-color', 'none');
    $('.animation-marker').removeClass('highlight');
  }

  render() {
    const { selectedMarker, shouldShowForm } = this.props;

    if (!selectedMarker) {
      return <div className="comment-detail-container"></div>;
    }

    return (
      <div className="comment-detail-container" ref={this.setWrapperRef}>
        {this.renderComentDetail(selectedMarker, shouldShowForm)}
      </div>
    );
  }
}
